import { LOGIN_KEY } from "./constants";

//Set the logged in user data in local session
export const setLoggeedInUser = (user) => {
  localStorage.setItem(LOGIN_KEY, JSON.stringify(user));
};

//Remove the logged in user data in local session
export const removeLoggedInUserDetails = () => {
  localStorage.removeItem(LOGIN_KEY);
};

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem(LOGIN_KEY);
  if (user) return JSON.parse(user);
  return null;
};

// get logged in user data by the key value pair
export const getLoggedInUserDataByKey = (key) => {
  const user = getLoggedInUser();
  return user[key];
};

//is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// logout user
export const logout = (history) => {
  removeLoggedInUserDetails();
  if (history) history.push("/");
  else window.location.href = "/";
};
